import MachineDetailNotification from "./MachineDetailNotification";
export default MachineDetailNotification;